import {useMutation} from '@tanstack/react-query';
import {GetOurDoctorMessageModel} from 'domain/usecases/private/home/get-our-doctor-message';
import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postOurDoctorMessage} from 'presentation/services/postOurDoctorMessage';

export const usePostOurDoctorMessageMutation = () =>
	useMutation({
		mutationFn: postOurDoctorMessage,
		retry: 1,
		onSuccess: data => {
			if (data?.mensagem) {
				queryClient.setQueryData(
					[QUERY_KEYS.OUR_DOCTOR_MESSAGE],
					(oldData: GetOurDoctorMessageModel) =>
						oldData
							? {...oldData, visualizou: true}
							: ({visualizou: true} as GetOurDoctorMessageModel),
				);
			}
		},
	});
